import React, { useEffect, useCallback, useState } from 'react'
import Layout from '../../../layout/Layout/Layout'
import { useSelector } from 'react-redux'
import { carouselCurrentItemSelector, carouselItemsSelector } from '../../../selectors'
import { Formik, Field, Form } from 'formik'
import Loading from 'custom/assets/loaders/Loading'
import Checkmark from 'custom/assets/icons/requests/709510'
import { useHistory } from 'react-router-dom'
import { accountsSelector } from '../../../selectors'
import DepositsService from '../../../services/deposits.service'
import InputError from '../../../components/InputError/InputError'
import { TopUpDepositSchema } from '../../../schemas/deposit'
import NumberFormat from 'react-number-format'

export default function TopUpDeposits() {
  const [stage, setStage] = useState(0)
  const current = useSelector(carouselCurrentItemSelector)
  const depositAccount = useSelector(accountsSelector)
  const accounts = useSelector(accountsSelector)
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [randomKey, setRandomKey] = useState('')
  const [otp, setOtp] = useState('')
  const history = useHistory()
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (depositAccount.length > 0) {
      setStage(1)
    }
  }, [depositAccount])

  const topupConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await DepositsService.topupDepositConfirm({
        termAccNo: formValues.termAccNo,
        debitAccNo: formValues.debitAccNo,
        topupAmount: formValues.topupAmount,
        remarks: '',
        debitAccBrn: accounts.find((x) => x.accountNo === formValues.debitAccNo).brnCode,
        accBrn: depositAccount.find((x) => x.accountNo === formValues.termAccNo).brnCode,
        accCcy: depositAccount.find((x) => x.accountNo === formValues.termAccNo).currency,
        otp,
        randomKey,
      })
      setMessage(response.message)
      setLoading(false)
      setStage(4)
    } catch (err) {
      setLoading(false)
    }
  }, [otp, randomKey, formValues])

  const topUpVerify = useCallback(async () => {
    try {
      setLoading(true)
      const response = await DepositsService.topupDepositVerify({
        termAccNo: formValues.termAccNo,
        debitAccNo: formValues.debitAccNo,
        topupAmount: formValues.topupAmount,
        remarks: '',
        debitAccBrn: accounts.find((x) => x.accountNo === formValues.debitAccNo).brnCode,
        accBrn: depositAccount.find((x) => x.accountNo === formValues.termAccNo).brnCode,
        accCcy: depositAccount.find((x) => x.accountNo === formValues.termAccNo).currency,
      })
      if (response.randomKeyEnable) {
        setRandomKey(response.randomKey)
      } else {
        setRandomKey('')
      }

      if (response.otpEnable) {
        setLoading(false)
        setStage(3)
      } else {
        setLoading(false)
        await topupConfirm()
      }
    } catch (err) {
      // setSubmitting(false)
      setLoading(false)
      setStage(1)
    }
  }, [topupConfirm])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return renderOTP()
      case 4:
        return renderSuccess()
      default:
        return renderLoading()
    }
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column'>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Deposit Account Number</h6>
          <h6>{formValues.termAccNo}</h6>
        </div>

        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Funding Account Number</h6>
          <h6>{formValues.debitAccNo}</h6>
        </div>

        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Topup Amount</h6>
          <h6>
          <NumberFormat
              value={formValues.topupAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
            />
          </h6>
        </div>

        <div className='mt-5 ml-auto px-0 col-3'>
          {loading ? (
            renderLoading()
          ) : (
            <button type='button' className='btn btn-neo' onClick={topUpVerify}>
              Confirm
            </button>
          )}
        </div>
      </div>
    )
  }
  const otpCallback = useCallback(async (e) => {
    const re = /^[0-9\b]+$/
    if (e.target.value === '' || re.test(e.target.value)) {
      setOtp(e.target.value)
    }
  }, [])

  function renderOTP() {
    return (
      <div className='my-4 py-4 d-flex xsflex-column text-center'>
        <div className='row'>
          <div className='col-8 mx-auto'>
            <div className='form-group colored-input'>
              <label className='control-label'>
                Please enter the OTP sent to your registered mobile number
              </label>
              <input
                required
                type='password'
                className='form-control text-center'
                pattern='[0-9]*'
                style={{ fontSize: 24 }}
                maxLength={4}
                value={otp}
                onChange={otpCallback}
              />
            </div>
            {/* <a className="small text-center" href="/">Resend OTP</a> */}
          </div>
        </div>
        <div className='mt-4 mx-auto px-0 col-3'>
          {loading ? (
            renderLoading()
          ) : (
            <button type='button' className='btn btn-neo' onClick={topupConfirm}>
              Submit
            </button>
          )}
        </div>
      </div>
    )
  }

  function renderSuccess() {
    return (
      <div className='my-5 py-5 d-flex flex-column text-center'>
        <img src={Checkmark} alt='Success' />
        <p className='mt-4 text-secondary'>{message}</p>
        <div className='mt-4 mx-auto px-0 col-3'>
          <button type='button' className='btn btn-neo' onClick={() => history.push('/deposits')}>
            Done
          </button>
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }
  function renderForm() {
    if (loading) {
      return (
        <div className='justify-content-center d-flex align-items-center'>
          <Loading />
        </div>
      )
    }

    return (
      <div>
        <Formik
          initialValues={{
            termAccNo: '',
            debitAccNo: '',
            topupAmount: '',
          }}
          validationSchema={TopUpDepositSchema}
          onSubmit={(data) => {
            setFormValues(data)
            setStage(2)
          }}>
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <div className='row'>
                <div className='form-group my-2 col-6'>
                  <label className='control-label'>Select Deposit Account</label>
                  <Field as='select' className='form-control' name='termAccNo'>
                    <option value='' />
                    {depositAccount.map((acc, i) => (
                      <option key={i} value={acc.accountNo}>
                        {acc.accountNo}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.termAccNo} touched={touched.termAccNo} />
                </div>

                <div className='form-group my-2 col-6'>
                  <label className='control-label'>Select Funding Account</label>
                  <Field as='select' className='form-control' name='debitAccNo'>
                    <option value='' />
                    {accounts.map((acc, i) => (
                      <option key={i} value={acc.accountNo}>
                        {acc.accountNo}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.debitAccNo} touched={touched.debitAccNo} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group my-2 col-6'>
                  <label className='control-label'>Topup Amount</label>
                  <Field as='input' className='form-control' name='topupAmount' type='number' />
                  <InputError text={errors.topupAmount} touched={touched.topupAmount} />
                </div>
              </div>
              <div className='mt-5 ml-auto px-0 col-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <button className='btn btn-neo' disabled={isSubmitting} type='submit'>
                    Topup
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
      <Layout>
        <div >
          <h4 className='font-weight-bold'>Deposits</h4>
          <p className='lead text-secondary'>select Account to TopUp Deposits</p>
          <div className='stages mt-5 mb-4'>
            <div className='mx-5 d-flex justify-content-between align-items-center'>
              <div>
                <h6 className='cursor-pointer selected'>TopUp Deposit</h6>
              </div>
            </div>
          </div>
          {renderSwitch()}
        </div>
      </Layout>
  )
}
